import React, { useRef, useEffect } from 'react';
import * as constantsViewer from '../../constants';
import { useSpring, a } from 'react-spring-beta/three';
import {
  DrawerButton,
  DrawerClassicHandle,
  DrawerSlat,
} from '../pieces/DrawerHandle';
import {
  DrawerFrontPane,
  DrawerFrontBottomShadow,
} from '../pieces/DrawerFrontPane';
import {
  onPointerDown,
  onPointerUp,
  manageOnClickComponent,
} from '../../helpers';
import { useDispatch } from 'react-redux';
import { applyPaintColor } from 'containers/PaintPanel/actions';

export function Drawer({
  drawer = null,
  cabinetId,
  shelfLevel,
  configuratorMode,
  cabinetWidth = 1000,
  cabinetDepth = 420,
  position = [0, 0, 0],
  level = 0,
  unselected = false,
}) {
  const group = useRef();
  const dispatch = useDispatch();

  const [spring, set] = useSpring(() => ({
    position: position,
    immediate: !constantsViewer.REACT_SPRING_ANIMATIONS_ACTIVE,
    config: constantsViewer.REACT_SPRING_ANIMATIONS_CONF,
  }));

  const drawerHandlesType = drawer.drawerHandlesType;
  const drawerHandle = drawer.handle;
  let drawerHandle3D = null;

  switch (drawerHandlesType) {
    case 'B':
      if (drawerHandle.length == 2)
        drawerHandle3D = (
          <>
            <DrawerButton
              drawerHandle={drawer.getDrawerHandle('FL')}
              bPosition="FL"
              cabinetWidth={cabinetWidth}
              cabinetDepth={cabinetDepth}
              unselected={unselected}
            />
            <DrawerButton
              drawerHandle={drawer.getDrawerHandle('FR')}
              bPosition="FR"
              cabinetWidth={cabinetWidth}
              cabinetDepth={cabinetDepth}
              unselected={unselected}
            />
          </>
        );
      else
        drawerHandle3D = (
          <DrawerButton
            drawerHandle={drawer.getDrawerHandle('F')}
            bPosition="C"
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            unselected={unselected}
          />
        );
      break;

    case 'K':
      if (drawerHandle.length == 2)
        drawerHandle3D = (
          <>
            <DrawerClassicHandle
              drawerHandle={drawer.getDrawerHandle('FL')}
              bPosition="FL"
              cabinetWidth={cabinetWidth}
              cabinetDepth={cabinetDepth}
              unselected={unselected}
            />
            <DrawerClassicHandle
              drawerHandle={drawer.getDrawerHandle('FR')}
              bPosition="FR"
              cabinetWidth={cabinetWidth}
              cabinetDepth={cabinetDepth}
              unselected={unselected}
            />
          </>
        );
      else
        drawerHandle3D = (
          <DrawerClassicHandle
            drawerHandle={drawer.getDrawerHandle('F')}
            bPosition="C"
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            unselected={unselected}
          />
        );
      break;

    case 'S':
      drawerHandle3D = (
        <DrawerSlat
          drawerHeight={drawer.height}
          cabinetWidth={cabinetWidth}
          cabinetDepth={cabinetDepth}
          unselected={unselected}
        />
      );

    default:
      break;
  }
  useEffect(() => {
    let self = group.current;
    if (self) {
      set({
        position: position,
      });
    }
  });
  // TODO not display simulation border when open
  return (
    <a.group
      ref={group}
      position={spring.position}
      onPointerDown={e => onPointerDown(e)}
      onPointerUp={e =>
        onPointerUp(e, e => {
          manageOnClickComponent(
            e,
            unselected,
            drawer,
            cabinetId,
            dispatch,
            configuratorMode,
            shelfLevel,
          );
        })
      }
    >
      <DrawerFrontPane
        drawer={drawer}
        cabinetWidth={cabinetWidth}
        cabinetDepth={cabinetDepth}
        level={level}
        unselected={unselected}
      />
      {level > 0 && (
        <DrawerFrontBottomShadow
          drawer={drawer}
          cabinetWidth={cabinetWidth}
          cabinetDepth={cabinetDepth}
          unselected={unselected}
        />
      )}

      {drawerHandle3D}
    </a.group>
  );
}
